import { useState } from "react";
import { Tabs } from "antd";
import { ThunderboltOutlined, RobotOutlined } from "@ant-design/icons";
import BasicReplies from "./BasicReplies";
import FlowList     from "./FlowList";

const WabaAutomation = ({ basePath }) => {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div style={{ marginBottom: 4 }}>
          <h2 style={{ margin: 0 }}>WhatsApp Automation</h2>
          <p style={{ margin: 0, color: "#6b7280", fontSize: 13 }}>
            Respond automatically to messages based on your own criteria
          </p>
        </div>
        <Tabs
          items={[
            {
              key: "basicReplies",
              label: <span><ThunderboltOutlined /> Basic Replies</span>,
              children: <BasicReplies />,
            },
            {
              key: "flows",
              label: <span><RobotOutlined /> Automations</span>,
              children: <FlowList basePath={basePath} />,
            },
          ]}
        />
      </div>
    </div>
  );
};

export default WabaAutomation;